import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useClipboard } from '@hooks';
import { useTheme } from '../../ThemeProvider';
import CopyCodeButton from '../CopyCodeButton/CopyCodeButton';
import classes from './Highlight.styles.less';
export default function Highlight({ children }) {
    const { copy, copied } = useClipboard();
    const [theme] = useTheme();
    return (_jsxs("div", { className: cx(classes.wrapper, classes[theme]), children: [_jsx(CopyCodeButton, { type: "button", copied: copied, className: classes.copy, onClick: () => copy(children) }), _jsx("div", { className: classes.highlight, children: _jsx("pre", { className: classes.code, children: _jsx("code", { children: children }) }) })] }));
}
